import { AppData } from 'src/app/shared/services/app-data.service';
import { AddressService } from './service/address.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/shared';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { ViewChild, Input, OnInit, Component, ElementRef } from '@angular/core';
import { AddressModel } from './model/address';
import { ADDRESS_BY_CITY, AGM_MAP_CUSTOM_STYLES, getConfig } from 'src/app/core/constants/app-constants';
import { getFormValidation } from 'src/app/shared/utils/common-functions';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { ErrorMessage } from 'src/app/core/constants/validation-msg-constants';
import { ActivatedRoute, Router } from '@angular/router';
import { Geolocation, Geoposition } from '@ionic-native/geolocation/ngx';
import { LocationAccuracy } from "@ionic-native/location-accuracy/ngx";
// import { AndroidPermissions } from "@awesome-cordova-plugins/android-permissions/ngx";
import { Diagnostic } from '@ionic-native/diagnostic/ngx'
import { NavController } from '@ionic/angular';
import { AddressSearchModalComponent } from './address-search-modal/address-search-modal.component';
import { AddEditAddressModalComponent } from './add-edit-address-modal/add-edit-address-modal.component';
import { CacheService } from 'src/app/shared/services/cache.service';


@Component({
    template: ''
})

export abstract class AddressComponent implements OnInit {
    addressForm: FormGroup;
    isSubmitted = false;
    addressModel = new AddressModel();
    lat: number;
    lng: number;
    addressOptionsCity = ADDRESS_BY_CITY;
    title = '';
    addressList = [];
    isFormInit = false;
    isOthersTag = false;
    locality = '';
    fullAddress = '';
    googleLocation = '';
    searchInputValue = '';
    locationConfirm = false;
    searchedLocation;
    addressName = '';
    userCurrentLat;
    userCurrentLang;
    mapSectionEnable = true;
    draggable = true;
    previous;
    titleTxt = "Delivery address";
    statusBarHeight = AppData.statusBarHeight;
    navigateBackUrl = ''
    inputLength = ''
    type: string
    editAddress
    redirectUrl
    queryParamsData

    public customStyle = AGM_MAP_CUSTOM_STYLES;

    constructor(
        private addressService: AddressService,
        private fb: FormBuilder,
        private toastService: ToastService,
        public router: Router,
        private geolocation: Geolocation,
        private modalService: NgbModal,
        private locationAccuracy: LocationAccuracy,
        public diagnostic: Diagnostic,
        // private androidPermissions: AndroidPermissions,
        private activateRoute: ActivatedRoute,
        private navCtrl: NavController,
        private cacheService: CacheService
    ) {
        this.addressService.init(this.setLocality.bind(this), this.setLatLng.bind(this),
            this.setFullAddress.bind(this), this.setCityStateCountry.bind(this), this.setGoogleLocation.bind(this));

        this.activateRoute.queryParams.subscribe((params) => {
            const queryParams = Object.assign({}, params)
            this.type = params['type']
            this.redirectUrl = params['redirectUrl']
            delete queryParams['type']
            const data = this.handleNavigationBack(queryParams)
            this.cacheService.setqueryParams(data)
        })
        this.editAddress = this.router.getCurrentNavigation().extras?.state?.data
    }

    ngOnInit() {

        if (this.type === 'ADD_ADDRESS' || this.type === 'ADD_ON_ADDRESS') {
            this.title = 'Add Address';
            const currentAddress = AppData.currentAddressObj
            const obj = {
                coords: {
                    lat: currentAddress.longLat.coordinates[1],
                    lng: currentAddress.longLat.coordinates[0]
                }
            }
            this.onGetLatLong(obj)
            // this.onGetCurrentLoca();
        } else {
            if (this.editAddress) {
                this.addressName = this.editAddress.locality;
                this.title = 'Edit Address';
                this.addressModel = Object.assign(this.addressModel, this.editAddress);
                this.lat = this.editAddress.longLat.coordinates[1];
                this.lng = this.editAddress.longLat.coordinates[0];
                this.fullAddress = this.editAddress.fullAddress;
            } else {
                this.setNavigationBack()

            }
        }

        this.getPosition();

    }

    handleNavigationBack(params) {
        let data = {}
        console.log(params)
        if (params.hasOwnProperty('navigateFrom')) {
            if (params.navigateFrom === '/favorites' || params.navigateFrom === '/order-history' || params.redirectUrl === '/rest-details') {
                params['redirectUrl'] = '/rest-details'
            } else if (params.navigateFrom === '/see-all-restaurants') {
                params['redirectUrl'] = '/rest-details'
            } else if (params.navigateFrom === '/see-all-dish') {
                params['redirectUrl'] = '/see-all-dish'
            } else if (params.navigateFrom === '/explore') {
                params['redirectUrl'] = '/rest-details'
            } else if (params.navigateFrom === '/rest-details') {
                params['redirectUrl'] = '/rest-details'
            }
        } else if (params.hasOwnProperty('promoId')) {
            params['redirectUrl'] = '/see-all-dish'
        } else if (params.hasOwnProperty('navFromExplore')) {
            params['redirectUrl'] = '/explore'
        } else if (params.redirectUrl === '/manage-address') {
            params['redirectUrl'] = '/account'
        }
        else {
            params['redirectUrl'] = '/home'
        }
        this.queryParamsData = Object.assign({}, params)
        data = {
            queryParams: this.queryParamsData
        }
        return data

    }

    getPosition() {
        this.geolocation.getCurrentPosition().then((resp) => {
            console.log("user current location ", resp)
            this.userCurrentLang = resp.coords.longitude;
            this.userCurrentLat = resp.coords.latitude;
            console.log("user current lat lng location ", this.userCurrentLang, this.userCurrentLat)
        })
            .catch((err) => {
                alert('Please allow location permission to determine your exact location for delivery.');
            })
    }
    onMouseOver(infoWindow, type) {
        console.log("fire");
        if (type == 'open') {
            infoWindow.open();
        } else {
            infoWindow.close();
        }

    }

    clickedMarker(infowindow) {
        console.log("fire on click")
        if (this.previous) {
            this.previous.close();
        }
        this.previous = infowindow;
        infowindow.open()
    }

    onCurrentMapClick(event) {
        console.log("map clicked  ", event)
        this.lat = this.userCurrentLat;
        this.lng = this.userCurrentLang
    }

    async onConfirmLocation() {
        const modalRef = this.modalService.open(AddEditAddressModalComponent, getConfig('MANAGE_ADDRESS_MODAL'));
        const latLng = {
            lat: this.lat,
            lng: this.lng,
            addressModel: this.addressModel,
            type: this.type
        }
        modalRef.componentInstance.modalObj = latLng;
        console.log(modalRef);
        modalRef.result.then(async (res) => {
            if (res) {
                console.log(res);
                await this.getYoursAddressUpdated('UPDATE')
                this.setNavigationBack(res)
            }
        }).catch((error) => {
            console.log(error);
        });

    }
    async getYoursAddressUpdated(type) {
        this.addressService.getAddressList().then((res) => {
            console.log(res['body']);
            const responseData = res['body']['data'];
            if (type === 'UPDATE') {
                const userInfo = AppData.userInfoData;
                userInfo['address'] = JSON.parse(JSON.stringify(responseData));
                AppData.userInfoSub$.next(userInfo);
            }
        }).catch((err) => {
        });
    }

    onChange() {
        const modalRef = this.modalService.open(AddressSearchModalComponent, getConfig('MANAGE_ADDRESS_MODAL'));
        modalRef.componentInstance.modalObj = '';
        console.log(modalRef);
        modalRef.result.then(async (res) => {
            console.log(res);
            this.handleAddressChange(res.address, res.inputValue)
        }).catch((error) => {
            console.log(error);
        });
    }

    onClose() {
    }

    setLatLng(lat, lng) {
        this.lat = lat;
        this.lng = lng;
        console.log(this.lat);
    }

    setLocality(val) {
        this.locality = val;
        this.addressModel._locality = this.locality;
        console.log(this.locality)
        // if(!this.addressName){
        this.addressName = this.addressModel._locality
        // }
    }

    setGoogleLocation(val) {
        this.googleLocation = val;
    }

    setCityStateCountry(city, state, country, pinCode) {
        this.addressModel['city'] = city;
        this.addressModel['state'] = state;
        this.addressModel['country'] = country;
        this.addressModel['pincode'] = pinCode;
    }

    setFullAddress(val) {
        this.fullAddress = val;
        this.addressModel._fullAddress = val;
        console.log(this.fullAddress)
        this.searchInputValue = this.fullAddress;
        console.log("addressForm ", this.addressForm);

    }

    handleAddressChange(address: Address, inputValue) {
        this.addressName = inputValue;
        console.log("name  ", inputValue);
        console.log(address);
        this.addressModel._fullAddress = address.formatted_address
        const obj = JSON.stringify(address.geometry.location);
        this.lat = JSON.parse(obj).lat;
        this.lng = JSON.parse(obj).lng;
        const adrObj = this.addressService.getCityStateCountry(address.address_components);
        const addressList = address.address_components;
        if (addressList.some(item => item.types[0] === 'sublocality_level_1')) {
            const subLocalityObj1 = addressList.find(item => item.types[0] === 'sublocality_level_1');
            this.addressModel._googleLocation = subLocalityObj1['long_name'];
        }
        // if (proceed) {
        this.addressService.getLocBaseOnLatLng(this.lat, this.lng);
        // }
        this.addressModel._locality = this.locality;
    }

    onGetLatLong(event) {
        if (event?.coords) {
            this.lat = event.coords.lat;
            this.lng = event.coords.lng;
            this.addressService.getLocBaseOnLatLng(this.lat, this.lng);
        } else {
            console.log(this.userCurrentLang, this.userCurrentLat);
            this.lat = this.userCurrentLat;
            this.lng = this.userCurrentLang
            this.addressService.getLocBaseOnLatLng(this.lat, this.lng);
        }
    }

    // Google Map Marker Dragging code
    markerDragEnd(event: any) {
        console.log(event);
        this.lat = event.coords.lat;
        this.lng = event.coords.lng;
        this.addressService.getLocBaseOnLatLng(this.lat, this.lng);
    }

    onGetCurrentLoc(event) {
        this.onGetLatLong(event);
        this.mapSectionEnable = true;
    }

    locationAccPermission() {
        this.locationAccuracy.canRequest().then((canRequest: boolean) => {
            if (canRequest) {
            } else {
                // this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.ACCESS_COARSE_LOCATION)
                //     .then((v) => {
                //         if (v.hasPermission) {
                //             this.enableGPS();
                //         }
                //     }, error => {
                //         console.log(error)
                //     });
            }
        });
    }
    enableGPS() {
        this.locationAccuracy.request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
            () => {
                this.getCurrentLocation()
            },
            error => console.log(JSON.stringify(error))
        );
    }

    async onGetCurrentLoca() {
        console.log(navigator);

        // this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.ACCESS_COARSE_LOCATION).then(
        //     result => {
        //         if (result.hasPermission) {
        //             this.enableGPS();
        //         } else {
        //             this.locationAccPermission();
        //         }
        //     },
        //     error => {
        //         console.log(error);
        //     });
    }
    getCurrentLocation() {
        this.geolocation.getCurrentPosition().then((resp) => {
            this.lat = resp.coords.latitude;
            this.lng = resp.coords.longitude;
            this.addressService.getLocBaseOnLatLng(this.lat, this.lng);
        })
            .catch((err) => {
                console.log(err);
                alert('Please enable location services to determine your exact location for delivery.');

                //this.createAlert();
                //this.askToTurnOnGPS();
            })

    }
    setNavigationBack(obj?) {
        console.log(this.queryParamsData)
        if (this.redirectUrl === '/cart') {
            this.queryParamsData['from'] = 'address'
            this.router.navigate([this.redirectUrl], { queryParams: this.queryParamsData, state: { data: obj } })

        } else {
            this.navCtrl.navigateBack([this.redirectUrl], { queryParams: { redirectUrl: '/account' } })
        }
    }
    onBack() {
        this.cacheService.setqueryParams('')
        if (this.redirectUrl === '/cart') {
            this.navCtrl.navigateBack([this.redirectUrl], { queryParams: this.queryParamsData })
        } else {
            this.navCtrl.navigateBack([this.redirectUrl], { queryParams: { redirectUrl: '/account' } })
        }
    }
}